<template>
    <modal :visible="visible">
        <template #header class="d-flex">
            <h2>{{ $t('fdb.dashboard.add_drivers') }}</h2>
            <div class="close-icon" @click="$emit('hide')">
                X
            </div>
        </template>
        <template #body>
            <b-row class="mt-3" v-for="(email, key) in emails" :key="key">
                <b-col cols="12" class="position-relative pr-4">
                    <b-form-input :state="errors[`emails.${key}`] ? !errors[`emails.${key}`][0] : null" :placeholder="$t('fdb.filter.email')" v-model="emails[key]"/>
                    <div class="remove-email-button" v-if="key !== 0" @click="removeEmail(key)">X</div>
                    <b-form-invalid-feedback id="input-live-feedback" v-if="errors[`emails.${key}`]">
                        {{ $t(errors[`emails.${key}`][0]) }}
                    </b-form-invalid-feedback>
                </b-col>

            </b-row>
            <b-row class="mb-3 mt-5 d-flex align-items-center justify-content-end">
                <flat-rounded-icon-button icon="plus" @click="emails.push('')" :disabled="canAddNextDriver">
                    {{ $t('fdb.dashboard.add_additional_driver') }}
                </flat-rounded-icon-button>
            </b-row>
        </template>
        <template #footer>
            <b-button variant="danger" class="ml-auto mt-3" @click="inviteDrivers">{{ $t('fdb.dashboard.invite_driver') }}</b-button>
        </template>
    </modal>
</template>

<script>
import Modal from "../atoms/Modal.vue";
import { BButton, BFormInput, BRow, BCol, BFormInvalidFeedback } from "bootstrap-vue";
import FlatRoundedIconButton from "../atoms/FlatRoundedIconButton.vue";

export default {
    name: 'DriverAddModal',
    components: { Modal, FlatRoundedIconButton, BFormInput, BButton, BRow, BCol, BFormInvalidFeedback },
    data() {
        return {
            emails: [''],
            errors: []
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async inviteDrivers() {
            try {
                await this.$axios.post('api/v1/fleetmanager/drivers', {
                    emails: this.emails
                })

                this.emails = ['']
                this.$emit('hide')
            } catch (error) {
                this.errors = error.response.data.errors
            }
            this.$emit('driversAdded')
        },
        removeEmail(index) {
            this.emails.splice(index, 1)
        }
    },
    computed: {
        canAddNextDriver() {
            return this.emails.some(email => {
                return !email.length
            })
        },
    }
}
</script>

<style lang="scss">
.remove-email-button {
    font-weight: bold;
    color: #ff4d4f;
    position: absolute;
    right: 2px;
    top: 5px;
    cursor: pointer;
}
</style>
